<template>
  <a-layout-content>
    <a-form layout="inline">
      <a-form-item>
        <a-button type="primary" :disabled="fileList.length === 0" :loading="uploading" @click="handleUpload">
          {{ uploading ? "上传" : "开始上传" }}
        </a-button>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="dowTemplate">
          下载模板
        </a-button>
      </a-form-item>
    </a-form>
    <div class="box">
      <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
        <a-button> <a-icon type="upload" /> 选择文件 </a-button>
      </a-upload>
    </div>
    <div style="color:red">
      <a-icon type="exclamation-circle" /> 上传文件顶部标头需要保留
      <br>
      <a-icon type="exclamation-circle" /> 注意文件上传仅支持上传.xlsx、.xls、.csv、后缀文件,建议使用CSV
      <br>
      <a-icon type="exclamation-circle" /> 会员账号不得超过50个字元
      <br>
      <a-icon type="exclamation-circle" /> 检查到错误将自动过滤跳过
      <br>
      <a-icon type="exclamation-circle" /> 请留意电子或真人排行榜设定的会员等级里的借支金额是否有设置,将会影响会员最高借款额度!!!!
      <br>
    </div>
  </a-layout-content>
</template>
<script>
  import XLSX from "xlsx";
  import { arrayExport } from "../../js/xlsxTool";
  export default {
    data() {
      return {
        fileList: [],
        uploading: false,
      };
    },
    methods: {
      isExcel(file) {
        return /\.(xlsx|xls|csv)$/.test(file.name);
      },
      handleRemove(file) {
        const index = this.fileList.indexOf(file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList;
      },
      beforeUpload(file) {
        if (!this.isExcel(file)) {
          this.$message.error("仅支持上传.xlsx、.xls、.csv、后缀文件");
          return false;
        }
        this.fileList = [file];
        return false;
      },
      handleUpload() {
        this.uploading = true;
        const that = this;
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            const data = e.target.result;
            const workbook = XLSX.read(data, { type: "array", raw: true });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            const header = that.getHeaderRow(worksheet);
            // 改变头部
            worksheet["A1"].w = "UserID";
            worksheet["B1"].w = "SlotID";
            worksheet["C1"].w = "LiveID";
            const results = XLSX.utils.sheet_to_json(worksheet);
            results.forEach(r => {
              r.SlotID = parseInt(r.SlotID) || 0;
              r.LiveID = parseInt(r.LiveID) || 0;
            });
            this.generateData({ header, results });
            resolve();
          };
          reader.readAsArrayBuffer(that.fileList[0]);
        });
      },
      generateData({ header, results }) {
        //进行上传
        this.uploading = false;
        this.fileList = [];
        this.axios.post("/UserMember/ImportUserMember",
          { UserList: results }
        ).then((res) => {
          if (res.data) {
            this.mymessage(this, "导入成功");
          }
        });
      },
      getHeaderRow(sheet) {
        const headers = [];
        const range = XLSX.utils.decode_range(sheet["!ref"]);
        let C;
        const R = range.s.r;
        for (C = range.s.c; C <= range.e.c; ++C) {
          const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })];
          let hdr = "UNKNOWN " + C;
          if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
          headers.push(hdr);
        }
        return headers;
      },
      // 下载模板
      dowTemplate() {
        var aoa = [
          ["会员账号", "电子等级", "真人等级"],
          ["ccc", "22", "33"]
        ];
        arrayExport(aoa, "会员上传模板");
      },
    },
    //首次加载
    created() {
    },
  };


</script>
<style>
  .box {
    width: 200px;
    height: 80px;
  }
</style>


// WEBPACK FOOTER //
// src/components/usermanage/userimport.vue